import type { Inbox } from '../api/types';
import { smsDefaultLine, smsDefaultStatus } from '../lib/smsDefault';
import { Note } from './ErrorNote';

/**
 * Where automated SMS stands, above a channel list: which number sends it, that
 * it is off, or that the number sending it is failing — and nothing at all for
 * a tenant with no number that could send it. Both channel lists render it
 * (ChannelsHome standalone, SettingsView inside the dashboard), because the
 * console is mounted more than one way and a line on one would be missing from
 * the other.
 */
export function SmsDefaultLine({
  inboxes,
  onOpenInbox,
}: {
  inboxes: Inbox[];
  /** How this mount opens an inbox's settings — a route, or a new tab from the embed. */
  onOpenInbox: (inboxId: number) => void;
}) {
  const status = smsDefaultStatus(inboxes);
  const line = smsDefaultLine(status);
  if (!line) return null;
  // A status region: it changes under the operator (a reconnect elsewhere, a
  // colleague moving the default) and says so without stealing focus.
  return (
    <div role="status" aria-label="Automated SMS">
      <Note tone={status.kind === 'broken' ? 'warn' : 'info'}>
        {line}
        {status.kind === 'broken' && (
          <>
            {' '}
            <button type="button" className="linklike" onClick={() => onOpenInbox(status.inbox.id)}>
              Reconnect
            </button>
          </>
        )}
      </Note>
    </div>
  );
}
